/**
 * useOutreachStatus / useOutreachPool — the two read-only "can I send right
 * now" questions the send dialog asks: is the deployment holding sends
 * (spec §11.8's banner), and which mailboxes can be picked.
 *
 * Both are outreach:read, so an admin_member sees them; the pool read here is
 * the campaign-scoped /outreach/mailboxes route, NOT /admin/outreach/pool
 * (outreach:manage). Both are gated on `enabled` so nothing is fetched until
 * a dialog actually opens.
 */
import { useQuery } from '@tanstack/react-query';
import type { OutreachPoolMailbox, OutreachSendStatus } from '@discovr/types';
import { campaignKeys } from '../queryKeys';
import { fetchOutreachPool, fetchOutreachStatus } from '../api/outreachApi';

export function useOutreachStatus(enabled: boolean) {
  return useQuery<OutreachSendStatus>({
    queryKey: campaignKeys.outreachStatus(),
    queryFn: fetchOutreachStatus,
    enabled,
    staleTime: 30_000,
  });
}

export function useOutreachPool(campaignId: string, enabled: boolean) {
  return useQuery<OutreachPoolMailbox[]>({
    queryKey: campaignKeys.outreachPool(campaignId),
    queryFn: () => fetchOutreachPool(campaignId),
    enabled: enabled && !!campaignId,
    staleTime: 30_000,
  });
}
